import { Injectable, HostListener } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class WindowWidthService {
  public windowWidth: number;

  constructor() {
    this.windowWidth = window.innerWidth;
  }

  @HostListener('window:resize', ['$event'])
  onResize(event) {
    this.windowWidth = event.target.innerWidth;
  }
}